<template>
  <div id="channel-checkbox-group">
    {{ label }}
    <v-container fluid class="ma-0 pa-0">
      <v-row>
        <v-col cols="12" sm="3" class="py-0 pr-0">
          <v-checkbox
            label="ch-A"
            :input-value="chA"
            @change="
              $emit('change', parseInt(`${+chD}${+chC}${+chB}${+$event}`, 2))
            "
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3" class="py-0 pr-0">
          <v-checkbox
            label="ch-B"
            :input-value="chB"
            @change="
              $emit('change', parseInt(`${+chD}${+chC}${+$event}${+chA}`, 2))
            "
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3" class="py-0 pr-0">
          <v-checkbox
            label="ch-C"
            :input-value="chC"
            @change="
              $emit('change', parseInt(`${+chD}${+$event}${+chB}${+chA}`, 2))
            "
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3" class="py-0 pr-0">
          <v-checkbox
            label="ch-D"
            :input-value="chD"
            @change="
              $emit('change', parseInt(`${+$event}${+chC}${+chB}${+chA}`, 2))
            "
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ChannelCheckboxGroup",
  props: {
    label: { Type: String, default: () => "" },
    channel: { Type: Number, default: () => 15 }
  },
  computed: {
    channels() {
      return parseInt(`${+this.chD}${+this.chC}${+this.chB}${+this.chA}`, 2);
    },
    chA() {
      return +this.toBin(this.channel)[3];
    },
    chB() {
      return +this.toBin(this.channel)[2];
    },
    chC() {
      return +this.toBin(this.channel)[1];
    },
    chD() {
      return +this.toBin(this.channel)[0];
    }
  },
  methods: {
    toBin(number) {
      return number.toString(2).padStart(4, "0");
    }
  }
};
</script>

<style></style>
